export const useCms = (request, opts = {}) => {
	const headers = {
		...opts.headers,
		"Content-Type": "application/json",
	};

	return useFetch(request, { 
		baseURL: 'http://152.42.210.32:3500/v1', 
		...opts,
		headers,
		body: opts.body ? JSON.stringify(opts.body) : undefined
	});
};